export function Emphasize({ children }: { children: React.ReactNode }) {
  return <span className="font-bold text-old-primary">{children}</span>
}
